export const CHAT = '/chat/' as const
export const CHAT_MESSAGE = `${CHAT}message/` as const
export const CHAT_MESSAGE_ALL = `${CHAT_MESSAGE}all` as const
